import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, takeUntil } from 'rxjs';
import {
  WhiteLabelPdfGendersStatistics,
  WhiteLabelTotalSessions,
  WhiteLabelTotalWithAverageSessions,
  WhiteLabelUsersCommentsWithRate,
} from 'src/app/core/data/model';
import { BlocState } from 'src/app/shared/bloc/base-bloc';
import { ColorsConstants } from 'src/app/shared/common';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { LayoutLoadingComponent } from 'src/app/shared/component/layout-loading/layout-loading.component';
import { StatisticsCardData, StatisticsFilterForm, TableFilter } from 'src/app/shared/interfaces';

import {
  StatisticsBloc,
  StatisticsChartInitEvent,
  StatisticsChartReadyState,
  StatisticsCommentsInitEvent,
  StatisticsCommentsLoadingState,
  StatisticsCommentsReadyState,
  StatisticsPDFGendersEvent,
  StatisticsReadyPDFState,
} from '../../bloc/statistics-bloc';
import { CommentsListComponent } from '../comments-list/comments-list.component';
import { DashboardFiltersComponent } from '../dashboard-filters/dashboard-filters.component';
import { StatisticsCardComponent } from '../statistics-card/statistics-card.component';
import { StatisticsChartSectionComponent } from '../statistics-chart-section/statistics-chart-section.component';
import { StatisticsPDFBloc } from '../../bloc/pdf-bloc';

@Component({
  selector: 'app-statistics-sections',
  standalone: true,
  imports: [
    CommonModule,
    LayoutLoadingComponent,
    CommentsListComponent,
    DashboardFiltersComponent,
    StatisticsCardComponent,
    StatisticsChartSectionComponent,
  ],
  templateUrl: './statistics-sections.component.html',
  styleUrls: ['./statistics-sections.component.scss'],
  providers: [StatisticsBloc],
})
export class StatisticsSectionsComponent extends BaseComponent implements OnInit {
  statisticsCardData: StatisticsCardData[] = [];
  statistics: WhiteLabelTotalWithAverageSessions;
  comments: WhiteLabelUsersCommentsWithRate;
  filter: BehaviorSubject<StatisticsFilterForm> = new BehaviorSubject<StatisticsFilterForm>(null);
  isCommentsLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  @Output() statisticsCardsDataEmitter: EventEmitter<StatisticsCardData[]> = new EventEmitter<StatisticsCardData[]>();
  @Output() statisticsCardsChartDataEmitter: EventEmitter<WhiteLabelTotalSessions> =
    new EventEmitter<WhiteLabelTotalSessions>();
  @Output() statisticsGendersEmitter: EventEmitter<WhiteLabelPdfGendersStatistics> =
    new EventEmitter<WhiteLabelPdfGendersStatistics>();

  @Output() commentsEmitter: EventEmitter<WhiteLabelUsersCommentsWithRate> =
    new EventEmitter<WhiteLabelUsersCommentsWithRate>();
  @Output() filterChange: EventEmitter<StatisticsFilterForm> = new EventEmitter<StatisticsFilterForm>();

  // constants
  ColorsConstants = ColorsConstants;

  constructor(injector: Injector, private bloc: StatisticsBloc, private pdfBloc: StatisticsPDFBloc) {
    super(['WHITE_LABEL_DASHBOARD'], injector);
    this.bloc.onState.pipe(takeUntil(this.destroy$)).subscribe((state) => this.onHandleBlocState(state));
  }

  //hooks
  ngOnInit(): void {}

  // publics
  onDashboardFilterChanged(filter: TableFilter<StatisticsFilterForm>): void {
    this.filter.next(filter.filter);
    this.pdfBloc.pdfReady$.next({
      ...this.pdfBloc.pdfReady$.value,
      statisticsGenderReady: false,
      statisticsCommentsReady: false,
      statisticsReady: false,
    });
    this.bloc.setEvent.next(new StatisticsChartInitEvent(filter.filter));
    this.bloc.setEvent.next(new StatisticsCommentsInitEvent(filter.filter));
    this.bloc.setEvent.next(new StatisticsPDFGendersEvent(filter.filter));
    this.filterChange.emit(filter.filter);
  }

  // overrides
  protected override onHandleBlocState(state: BlocState): void {
    super.onHandleBlocState(state);
    if (state instanceof StatisticsChartReadyState) {
      this.statistics = state.statistics;
      this.setStatisticsCardData();
      this.statisticsCardsDataEmitter.emit(this.statisticsCardData);
      this.statisticsCardsChartDataEmitter.emit(this.statistics.totals);
      this.pdfBloc.pdfReady$.next({ ...this.pdfBloc.pdfReady$.value, statisticsReady: true });
    } else if (state instanceof StatisticsCommentsReadyState) {
      this.comments = state.comments;
      this.isCommentsLoading.next(false);
      this.commentsEmitter.emit(this.comments);
      this.pdfBloc.pdfReady$.next({ ...this.pdfBloc.pdfReady$.value, statisticsCommentsReady: true });
    } else if (state instanceof StatisticsCommentsLoadingState) {
      this.isCommentsLoading.next(true);
    } else if (state instanceof StatisticsReadyPDFState) {
      this.statisticsGendersEmitter.emit(state.statistics);
      this.pdfBloc.pdfReady$.next({ ...this.pdfBloc.pdfReady$.value, statisticsGenderReady: true });
    }
  }

  // privates

  private setStatisticsCardData(): void {
    this.statisticsCardData = [
      // {
      //   percentage: this.statistics.averages.minutesAverageData.rate || 0,
      //   cardHeaderLabel: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_CARD']['AVERAGE_SESSION_MINUTES'],
      //   statisticsLabel: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_CARD']['MINUTES'],
      //   statisticsPercent: this.statistics.averages.minutesAverageData.average || 0,
      // },
      // {
      //   percentage: this.statistics.averages.pagesData.rate || 0,
      //   cardHeaderLabel: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_CARD']['AVERAGE_FACE_FOR_CLIENT'],
      //   statisticsLabel: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_CARD']['FACE'],
      //   statisticsPercent: this.statistics.averages.pagesData.average || 0,
      // },
      // {
      //   percentage: this.statistics.averages.sessionData.rate || 0,
      //   cardHeaderLabel:
      //     this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_CARD']['AVERAGE_SESSIONS_NUMBER_FOR_CLIENT'],
      //   statisticsLabel: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_CARD']['SESSION'],
      //   statisticsPercent: this.statistics.averages.sessionData.average || 0,
      // },
    ];
  }
}
